export function setDistributionOutletInSessionStorage(distributionOutlet) {
  sessionStorage.setItem('vertriebsstelle', distributionOutlet);
}

export function getDistributionOutletFromSessionStorage() {
  return sessionStorage.getItem('vertriebsstelle');
}

export function checkDistributionOutletInSessionStorage() {
  const distributionOutlet = sessionStorage.getItem('vertriebsstelle');
  return distributionOutlet !== null && distributionOutlet !== '';
}
